import { render, staticRenderFns } from "./Changes.vue?vue&type=template&id=56934ae5&scoped=true"
import script from "./Changes.vue?vue&type=script&lang=js"
export * from "./Changes.vue?vue&type=script&lang=js"
import style0 from "./Changes.vue?vue&type=style&index=0&id=56934ae5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56934ae5",
  null
  
)

export default component.exports